import React from 'react';
import './MissionVision.css';

const MissionVision = () => {
  return (
    <section className="mission-vision-section section">
      <h2 className="section-title">Mission & Vision</h2>
      
      <div className="mission-vision-content">
        <div className="mission-container">
          <div className="mission-header">
            <h3>Our Mission</h3>
          </div>
          <p>
            Our mission is to empower industries with high-performance tools that enhance productivity 
            and reduce operational costs. We strive to deliver products that are reliable, durable, 
            and tailored to the specific needs of each client. Through innovation, technical excellence, 
            and exceptional customer service, we aim to be the go-to choice for precision tools globally.
          </p>
        </div>
        
        <div className="vision-container">
          <div className="vision-header">
            <h3>Our Vision</h3>
          </div>
          <p>
            We envision a world where precision and efficiency go hand in hand, driving industries 
            towards sustainable growth. As a leader in tool manufacturing, we are committed to 
            pushing the boundaries of what is possible, continuously setting new benchmarks in 
            quality and innovation. Our goal is to expand our global reach, ensuring that every industry, 
            big or small, has access to the best tooling solutions available.
          </p>
        </div>
      </div>
      
      <div className="values-container">
        <h3 className="values-title">Our Core Values</h3>
        <ul className="values-list">
          <li className="value-item">
            <span className="value-name">Excellence</span>
            <p className="value-description">
              We pursue the highest standards of quality in all our products and services.
            </p>
          </li>
          <li className="value-item">
            <span className="value-name">Innovation</span>
            <p className="value-description">
              We continuously explore new technologies and methods to improve our products.
            </p>
          </li>
          <li className="value-item">
            <span className="value-name">Integrity</span>
            <p className="value-description">
              We conduct business with honesty, transparency, and ethical principles.
            </p>
          </li>
          <li className="value-item">
            <span className="value-name">Customer Focus</span>
            <p className="value-description">
              We prioritize understanding and meeting our customers' needs and expectations.
            </p>
          </li>
          <li className="value-item">
            <span className="value-name">Sustainability</span>
            <p className="value-description">
              We are committed to environmentally responsible practices in our operations.
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default MissionVision;
